import ApolloClientHexaService from 'ApolloClientHexaService';
import { LOGIN, RESET_PASSWORD } from 'gql/auth';

export const loginHandler = async ({ email, password }) => {
  try {
    const { data } = await ApolloClientHexaService.mutate({
      mutation: LOGIN,
      variables: { input: { email: email?.toLowerCase(), password } },
    });

    return {
      success: true,
      error: false,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error: { ...error },
      data: null,
    };
  }
};

export const resetPassword = async ({ updatedPassword, id }) => {
  try {
    const { data } = await ApolloClientHexaService.mutate({
      mutation: RESET_PASSWORD,
      variables: { input: { id, updatedPassword } },
    });
    return {
      success: true,
      error: false,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error: { ...error },
      data: null,
    };
  }
};
